import { assign } from '@atds-legacy/lang';
import { Component, SDK, deserialize } from '@redge-media/fo-js-sdk';

const Info = Component.mixin({ deserialize }).extend({
  method: 'get',
  endpoint: 'info',
  _promise: undefined,

  constructor: function Info() {
    Component.call(this);

    this.isFetched = false;
    this.serverTimestamp = 0;
  },

  fetch(opts = {}) {
    if (this._promise && !opts.sync) {
      return this._promise;
    }

    this._promise = SDK.apiAdapter[this.method](this.endpoint);

    this._promise.then((response) => {
      const data = this.deserialize(response, opts);
      data.serverTimestamp = data.serverTimestamp || new Date(response.headers.date).getTime();
      assign(this, data);

      this.emit('sync', this.method, this);
      this.isFetched = true;
      return this;
    }).catch(() => {
      this.isFetched = false;
      this._promise = undefined;
      this.emit('sync', this.method, this);
      return this;
    });

    return this._promise;
  },
});

export default Info;
